import { useCadastros, useToastSaurus } from "services/app";
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { Controller, useForm } from "react-hook-form";
import { ConfirmarIcon } from "views/components/icons/confirmar-icon";
import { useStyles } from "./dialog-indicacao-revenda-styles";
import { useDialogIndicacaoRevendaValidation } from "./dialog-indicacao-revenda-validations";
import { yupResolver } from "@hookform/resolvers/yup";
import { AvancarIcon, OkIcon, VoltarIcon } from "views/components/icons";
import { useEffect, useRef, useState } from "react";
import { IndicacaoRevendedorProps, usePostIndicacaoRevendedor } from "data/api/gestao/indicacao-revendedores/post-indicacao-revendedor";
import { CircularLoading } from "views/components/utils";
import { useThemeQueries } from "views/theme";

export interface DialogIndicacaoRevendaProps {
    openned: boolean;
}

export const DialogIndicacaoRevenda = ({ openned }: DialogIndicacaoRevendaProps) => {

    const { fecharCadastroIndicacaoRevendedor } = useCadastros()
    const { DialogIndicacaoRevendaValidationYup } = useDialogIndicacaoRevendaValidation()
    const { postIndicacaoRevendedor, carregando } = usePostIndicacaoRevendedor()
    const classes = useStyles()
    const { showToast } = useToastSaurus()
    const [isSuccess, setIsSuccess] = useState(false);
    const campoCnpjRef = useRef<HTMLInputElement>(null)
    const { isMobile } = useThemeQueries()

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm<IndicacaoRevendedorProps>({
        defaultValues: {
            cnpj: ''
        },
        resolver: yupResolver(DialogIndicacaoRevendaValidationYup),
        mode: "onBlur",
        reValidateMode: "onBlur",
        shouldUnregister: true,
    });

    const onSubmit = async (data: IndicacaoRevendedorProps) => {
        try {
            const res = await postIndicacaoRevendedor(data)
            if (res.erro) throw res.erro

            setIsSuccess(true)
        } catch (err: any) {
            showToast('error', err.message)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            if (campoCnpjRef.current && !isMobile) {
                campoCnpjRef.current?.focus()
            }
        }, 100)
    }, [isMobile])

    return (
        <DialogSaurus
            aberto={openned}
            tamanho='sm'
        >
            {!isSuccess ? (
                <Box p={2} component={"form"} onSubmit={handleSubmit(onSubmit)}>
                    {carregando && <CircularLoading tipo="FULLSIZED" />}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h4" align="center" className={classes.title}>Indicação de Revenda</Typography>
                            <Typography variant="body2" align="center">
                                Você está prestes a indicar um revendedor. Por favor, preencha os dados da revenda para concluir o processo.
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="cnpj"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextFieldSaurus
                                        {...field}
                                        tipo="CNPJ"
                                        variant="outlined"
                                        inputRef={campoCnpjRef}
                                        fullWidth
                                        label="CNPJ do Revendedor"
                                        helperText={
                                            errors.cnpj
                                                ? errors.cnpj.message
                                                : undefined
                                        }
                                        error={Boolean(
                                            errors.cnpj && errors.cnpj.message,
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="nomeComercial"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextFieldSaurus
                                        {...field}
                                        tipo="TEXTO"
                                        variant="outlined"
                                        fullWidth
                                        label="Nome Comercial"
                                        helperText={
                                            errors.nomeComercial
                                                ? errors.nomeComercial.message
                                                : undefined
                                        }
                                        error={Boolean(
                                            errors.nomeComercial && errors.nomeComercial.message,
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="responsavel"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextFieldSaurus
                                        {...field}
                                        tipo="TEXTO"
                                        variant="outlined"
                                        fullWidth
                                        label="Nome do Responsável"
                                        helperText={
                                            errors.responsavel
                                                ? errors.responsavel.message
                                                : undefined
                                        }
                                        error={Boolean(
                                            errors.responsavel && errors.responsavel.message,
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="telefone"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <TextFieldSaurus
                                        {...field}
                                        tipo="TELEFONE"
                                        variant="outlined"
                                        fullWidth
                                        allowSubmit
                                        label="Telefone"
                                        helperText={
                                            errors.telefone
                                                ? errors.telefone.message
                                                : undefined
                                        }
                                        error={Boolean(
                                            errors.telefone && errors.telefone.message,
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} container justifyContent="center" direction="column">
                            <Typography variant="caption" align="center">
                                Caso tenha dúvidas, entre em contato com o suporte.
                            </Typography>
                            <Button type="submit" variant="contained" color="primary" fullWidth size="large">
                                <ConfirmarIcon tipo="BUTTON_PRIMARY" />
                                Confirmar
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={fecharCadastroIndicacaoRevendedor} variant="outlined" color="primary" fullWidth size="large">
                                <VoltarIcon tipo="BUTTON" />
                                Voltar
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            ) : (
                <Box p={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h4" align="center" className={classes.title}>
                                Indicação de Revenda
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" align="center">
                                Agradeço por indicar uma nova revenda.
                            </Typography>
                            <Typography variant="body1" align="center">
                                Recebemos os dados e em breve nossa equipe entrará em contato com a revenda indicada.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} container justifyContent="center">
                            <OkIcon tipo="GERAL" class={classes.sucesso} />
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={fecharCadastroIndicacaoRevendedor} variant="contained" color="primary" fullWidth size="large">
                                <AvancarIcon tipo="BUTTON_PRIMARY" />
                                Continuar
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </DialogSaurus>
    )
}